import React, { ReactElement } from 'react';
import { Immutable } from '@wds/utils';
import { List } from '@wds/list';

export type SubMenuItemProps = Immutable<{
  title?: string;
  name?: string;
  path?: string;
  url?: string;
  openInNewWindow?: boolean;
  show?: boolean;
  metrics?: String;
}>;

export const SubMenuItem = ({
  title = '',
  name = '',
  path = '',
  url = '',
  openInNewWindow = false,
  show = true,
  metrics = '',
}: SubMenuItemProps): ReactElement | null => {
  const itemTitle = name || title;
  const itemURL = path || url;

  if (!itemTitle || !itemURL || !show) return null;

  const currentPath = document.location.pathname;
  const isActive = path.startsWith(currentPath);

  return (
    <List.Item
      key={itemTitle}
      isNavigable
      navigationTarget={itemURL}
      data-sm-metrics={metrics}
      {...(openInNewWindow === true && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
      color={isActive ? 'primary' : undefined}
      marker={isActive}
    >
      {itemTitle}
    </List.Item>
  );
};

export default SubMenuItem;
